import { Subject } from 'rxjs';
import { Observable, forkJoin } from 'rxjs';
import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckOutService } from '../../../services/checkout.service';
import { CommonService } from '../../../services/common.service';
import { CheckoutSummaryViewModel, ShippingAddress, PaymentViewModel, OrderConfirmationViewModel, CheckoutStatusModel } from '../../../models/check-out.model';
import { CartDetailViewModel } from '../../../models/cart-item.model';
import { ShoppingCartService } from '../../../services/shopping-cart.service';
import { ShoppingCart } from '../../../models/shopping-cart.model';
import { CurrentUserModel } from '../../../models/account-ledger.model';
import { AuthService } from '../../../services/auth.service';
import { AppState } from '../../../reducers';
import { Store } from '@ngrx/store';
import { getShoppintCartItemLoading } from '../../../reducers/shoppingcart.reducer';
import { CheckoutShoppingCart } from '../../../actions/shoppingcart.actions';
import * as moment from 'moment';
import { map, switchMap, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-summary-order',
    templateUrl: './summary-order.component.html',
    styleUrls: ['./summary-order.component.css']
})
export class SummaryOrderComponent implements OnInit, OnDestroy {
    @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;
    title = 'Your Order Summary';

    // set timer for payway (10 mins)
    showTimer = false;
    counter: string;
    validTime = 580;
    timeLeft: number;

    setFullWindow = false;
    firstStep: string;
    showDelivery = true;
    loadContent = false;
    cartId: string;
    cartName: string;
    checkoutSummary: CheckoutSummaryViewModel;
    deliverySummary: ShippingAddress;
    paymentSummary: PaymentViewModel;
    partshipSummary: ShippingAddress;
    cartDetails: CartDetailViewModel[];
    randomNameArray: string;
    shoppingCarts: ShoppingCart[];
    checkoutStatus: CheckoutStatusModel;
    currentUserModel: CurrentUserModel;
    isOrderPlaced = false;
    serial: string;

    backto: string;

    quoteId: string;

    loadSummary: boolean = false;
    ngUnsubscribe: Subject<void> = new Subject<void>();

    constructor(private router: Router
        , private activatedRoute: ActivatedRoute
        , private checkOutService: CheckOutService
        , private commonService: CommonService
        , private authService: AuthService
        , private store: Store<AppState>
        , private shoppingCartService: ShoppingCartService) { }

    ngOnInit() {

        this.store.select(getShoppintCartItemLoading).subscribe(isLoading => {
            this.loadContent = !isLoading;
        });

        // this.activatedRoute.parent.parent.paramMap.subscribe((params) => {
        //     this.serial = params.get('serial');
        // })

        this.activatedRoute.parent.parent.parent.paramMap.pipe(
            switchMap((params) => {
                return this.activatedRoute.parent.parent.paramMap.pipe(
                    map((param) => {
                        return {
                            quoteId: params.get('sku'),
                            serial: param.get('serial'),
                        }
                    })
                )
            })
        ).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
            this.quoteId = res.quoteId;
            this.serial = res.serial;
            if (this.quoteId) {
                this.backto = 'quote';
            } else if (this.serial) {
                this.backto = 'renewal';
            } else {
                this.backto = 'cart';
            }
        })


        this.activatedRoute.parent.url
            .subscribe(value => {
                this.cartId = value.length > 1 ? value[1].path : '';
                this.cartName = value.length > 1 ? value[2].path : '';
                this.loadContent = true;
                this.isOrderPlaced = false;
            },
                (error: any) => {
                    console.error(error);
                    this.loadContent = true;
                });

        this.checkOutService.changeEmitted$.subscribe(res => {
            this.firstStep = res.firstStep;

            if (this.firstStep === 'TENANT' || this.firstStep === 'ENDUSER' || this.firstStep === 'PAYMENT') {
                this.showDelivery = false;
            }
        });

        this.loadSummary = false;
        forkJoin(
            [this.authService.getLoginInfo(),
            this.checkOutService.GetSummaryView(this.commonService.toNumber(this.cartId))]
        ).pipe(takeUntil(this.ngUnsubscribe))
         .subscribe(results => {
            this.currentUserModel = results[0];
            this.checkoutSummary = results[1];

            this.deliverySummary = this.checkoutSummary.shippingAddress;
            this.paymentSummary = this.checkoutSummary.payment;
            this.partshipSummary = this.checkoutSummary.shippingAddress;
            this.cartDetails = this.checkoutSummary.cartDetail;
            
            // Timer for CREDIT CARD (AU only)
            if (this.currentUserModel.isAU && this.paymentSummary.paymentMethod === 'CREDIT CARD') {
                this.showTimer = true;
                this.timeLeft = this.validTime;
                this.startTimer();
            }
            this.commonService.applyScrollFixedHeader(this.parentWrapper);
            this.loadSummary = true;
         },
         (error: any) => {
            console.error(error);
            this.loadSummary = true;
         });

    }

    goPrevious(): void {
        this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
    }

    placeOrder(): void {

        this.isOrderPlaced = true;
        console.log(this.cartId);
        console.log(this.cartName);
        this.store.dispatch(new CheckoutShoppingCart({ cartId: this.commonService.toNumber(this.cartId), cartName: this.cartName }));

    }

    addNewCart(): void {
        this.loadContent = false;
        this.randomNameArray = this.shoppingCartService.RandomCartName(this.shoppingCarts);
        this.shoppingCartService.createShoppingCart(this.randomNameArray).subscribe((res: number) => {
            this.shoppingCartService.monitorCartId(res);
            this.shoppingCartService.monitorCartIdChange(res);
            this.commonService.savecookies('CartId', res.toString(), 7);
            this.commonService.showSuccess('.btnAdd', 'Create Shopping Cart Successfully', 'right');
            this
                .shoppingCartService
                .getShoppingCart()
                .subscribe(sc => {
                    this.shoppingCarts = sc;
                    this.loadContent = true;
                },
                    (error: any) => {
                        console.error(error);
                        this.loadContent = true;
                    });

        },
            (error: any) => {
                this.commonService.showError('.btnAdd', error.responseMessage, 'right');
                this.loadContent = true;
            });
    }

    onLoading(currentLoadingStatus: boolean) {
        this.loadContent = !currentLoadingStatus;
    }
    backtoCart() {
        this.checkOutService.monitorShowCartSummary('show');
        this.router.navigateByUrl(`/myCarts/cart/${this.cartId}/${this.cartName}`);
    }

    backtoRenewals() {
        this.router.navigate(['.'],{relativeTo:this.activatedRoute.parent.parent});
        //this.router.navigateByUrl(`manageRenewalsNew/renewalDetails/${this.serial}`);
    }

    backtoQuotes() {
        this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent.parent });
        $('.combination-loader').animate(
          { scrollLeft: (250 + $('#price-list-detail').width()) }, 100)
    
      }
      
    startTimer() {
        const countDownDate = moment().add(this.timeLeft, 'seconds');
        const timer = setInterval(() => {
            const diff = countDownDate.diff(moment());

            if (diff <= 0) {   // time out
                clearInterval(timer);
                this.timeLeft = 0;
                this.commonService.implementToast('Credit card payment session timeout', 'Error', true);
                this.serial ? this.backtoRenewals() : this.backtoCart();

            } else {
                this.counter = moment.utc(diff).format('mm:ss');
            }

        }, 1000);
    }


    close() {
        this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
